<template>
    <div id="modal-detalhes-nps-detratores" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 id="ModalLabel" class="modal-title d-flex justify-content-between align-items-center w-100">
                        <span>{{ detalhes.nome_empresa }}</span>
                        <div class="contatos-header">
                            <span v-if="detalhes.telefone" class="me-3">
                                <i class="fas fa-phone me-1"></i>
                                {{ formatarTelefone(detalhes.telefone) }}
                            </span>
                            <span v-if="detalhes.celular">
                                <i class="fas fa-mobile-alt me-1"></i>
                                {{ formatarTelefone(detalhes.celular) }}
                            </span>
                        </div>
                    </h5>
                </div>
                <div class="modal-body">

                    <div class="d-flex">
                        <button :class="tabs == 0 ? 'btn btn-dark' : 'btn btn-outline-dark'" type="button"
                            @click="tabs = 0" style="margin-right: 8px;">Respostas ({{ respostas.length }})</button>

                        <button :class="tabs == 1 ? 'btn btn-dark' : 'btn btn-outline-dark'" type="button"
                            @click="tabs = 1">Follow-up ({{ followUps.length }})</button>
                    </div>

                    <div class="body-card">
                        <div class="limit-div" v-if="tabs == 0">
                            <div class="filtros-container mb-3">
                                <div class="search-container">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="searchQuery"
                                            placeholder="Buscar por usuário ou tipo...">
                                    </div>
                                </div>
                                <div class="sort-container">
                                    <select class="form-select" v-model="sortOrder">
                                        <option value="asc">Nota (Menor para Maior)</option>
                                        <option value="desc">Nota (Maior para Menor)</option>
                                    </select>
                                </div>
                            </div>

                            <div class="card mb-2" v-for="resp of filteredAndSortedRespostas" :key="resp.id">
                                <div class="p-2 d-flex card-header align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <span class="text-uppercase font-weight-bold text-dark overflow-text me-2">
                                            {{ resp.nome_usuario ?? 'Não informado' }}
                                        </span>
                                    </div>
                                    <span class="badge badge-danger">
                                        Nota: {{ resp.resposta }}
                                    </span>
                                </div>
                                <div class="p-2 card-body">
                                    <h6 class="mt-0 text-sm text-muted">
                                        {{ resp.observacao ? resp.observacao : '*** Não informado ***' }}
                                    </h6>
                                </div>
                                <div class="card-footer p-1 pe-3 d-flex justify-content-between">
                                    <div>
                                        <span class="badge badge-primary me-2">
                                            {{ resp.tipo_usuario }}
                                        </span>
                                    </div>
                                    <span class="text-muted text-xs">
                                        <i class="fas fa-clock"></i>
                                        {{ filters.formatDateTime(resp.data) }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div v-if="tabs == 1">
                            <div class="d-flex justify-content-end mb-4">
                                <button type="button"
                                    :class="['btn', showFollowUpForm ? 'btn-dark' : 'btn-outline-dark']"
                                    @click="showFollowUpForm = !showFollowUpForm">
                                    {{ showFollowUpForm ? 'Cancelar' : 'Incluir Follow-up' }}
                                </button>
                            </div>

                            <form v-if="showFollowUpForm" @submit.prevent="onSubmitFollowUp" class="mb-4">
                                <div class="card no-hover">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <label>Data do Follow-up</label>
                                                <datepicker v-model="followUp.data" locale="pt-BR"
                                                    :month-change-on-scroll="false" format="dd/MM/yyyy" auto-apply
                                                    :enable-time-picker="false" class="form-control" />
                                                <div class="text-danger text-xs" v-if="errors.data">
                                                    {{ errors.data }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-3">
                                            <div class="col-md-12">
                                                <label>Observação</label>
                                                <textarea v-model="followUp.observacao" class="form-control" rows="4"
                                                    placeholder="Digite sua observação..."></textarea>
                                                <div class="text-danger text-xs" v-if="errors.observacao">
                                                    {{ errors.observacao }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex justify-content-end mt-4">
                                            <button type="submit" class="btn bg-gradient-success">
                                                Salvar Follow-up
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <!-- Lista de Follow-ups -->
                            <div class="follow-up-counter mb-3">
                                <div class="counter-badge">
                                    <i class="fas fa-history me-2"></i>
                                    <span class="counter-number">{{ followUps.length }}</span>
                                    <span class="counter-text">{{ followUps.length === 1 ? 'Follow-up registrado' :
                                        'Follow-ups registrados' }}</span>
                                </div>
                            </div>
                            <div class="timeline-container">
                                <div v-if="followUps.length === 0" class="text-center py-4">
                                    <i class="fas fa-clipboard-list text-muted mb-2" style="font-size: 2rem;"></i>
                                    <p class="text-muted mb-0">Nenhum follow-up registrado</p>
                                </div>
                                <div v-else class="timeline">
                                    <div v-for="(item) in followUps" :key="item.id" class="timeline-item">
                                        <div class="timeline-dot"></div>
                                        <div class="timeline-content">
                                            <div class="timeline-date">
                                                <div class="date-group">
                                                    <div>
                                                        <i class="fas fa-calendar-check me-2"></i>
                                                        <span class="date-label">Data:</span>
                                                        {{ formatDate(item.data) }}
                                                    </div>
                                                    <div>
                                                        <i class="fas fa-clock me-2"></i>
                                                        <span class="date-label">Registrado em:</span>
                                                        {{ filters.formatDateTime(item.createdAt) }} - {{
                                                            filters.firstAndLastName(item.createdBy.nome) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="timeline-body">
                                                {{ item.observacao }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn bg-gradient-dark btn-sm" data-bs-dismiss="modal">
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { successToast, errorToast } from '@/utils/alerts';
import api from '@/services/api';

export default {
    name: "ModalDetalhesNpsDetratores",
    props: {
        detalhes: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        Datepicker
    },
    data() {
        return {
            tabs: 0,
            followUps: [],
            respostas: [],
            showFollowUpForm: false,
            followUp: {
                data: new Date(),
                observacao: '',
                nps: null,
                quizHotelId: null,
                empresaHotelId: null
            },
            searchQuery: '',
            sortOrder: 'desc',
            errors: {
                data: '',
                observacao: ''
            }
        }
    },
    computed: {
        filteredAndSortedRespostas() {
            let respostas = [...(this.respostas || [])];

            // Filtragem
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                respostas = respostas.filter(resp => {
                    const nomeUsuario = (resp.nome_usuario || '').toLowerCase();
                    const tipoUsuario = (resp.tipo_usuario || '').toLowerCase();
                    return nomeUsuario.includes(query) || tipoUsuario.includes(query);
                });
            }

            // Ordenação
            respostas.sort((a, b) => {
                const notaA = parseInt(a.resposta) || 0;
                const notaB = parseInt(b.resposta) || 0;
                return this.sortOrder === 'asc' ? notaA - notaB : notaB - notaA;
            });

            return respostas;
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleDateString('pt-BR');
        },
        formatDateTime(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleString('pt-BR');
        },
        formatarTelefone(telefone) {
            if (!telefone) return '';

            // Remove tudo que não for número
            const numero = telefone.replace(/\D/g, '');

            // Verifica se tem a quantidade correta de dígitos
            if (numero.length !== 10 && numero.length !== 11) return telefone;

            // Formata como (00) 00000-0000 ou (00) 0000-0000
            if (numero.length === 11) {
                return `(${numero.slice(0, 2)}) ${numero.slice(2, 7)}-${numero.slice(7)}`;
            } else {
                return `(${numero.slice(0, 2)}) ${numero.slice(2, 6)}-${numero.slice(6)}`;
            }
        },
        async loadFollowUps() {
            try {
                const response = await api.get(`/follow-up-nps/nps/${this.detalhes.nps_id}/empresa/${this.detalhes.empresa_hotel_id}`);
                this.followUps = response.data;
            } catch (error) {
                console.error('Erro ao carregar follow-ups:', error);
                this.$notify({
                    type: 'danger',
                    message: 'Erro ao carregar follow-ups. Tente novamente.'
                });
            }
        },
        async loadRespostas() {
            try {
                const { data } = await api.get(`/nps/detratores/${this.detalhes.hotel_quiz_id}/${this.detalhes.empresa_hotel_id}`);

                this.respostas = data;
            } catch (error) {
                console.error('Erro ao carregar respostas:', error);
                this.$notify({
                    type: 'danger',
                    message: 'Erro ao carregar respostas. Tente novamente.'
                });
            }
        },
        async onSubmitFollowUp() {
            this.errors = {
                data: '',
                observacao: ''
            };

            if (!this.followUp.data) {
                this.errors.data = 'A data é obrigatória';
                return;
            }

            if (!this.followUp.observacao) {
                this.errors.observacao = 'A observação é obrigatória';
                return;
            }

            try {
                const response = await api.post('/follow-up-nps', {
                    ...this.followUp,
                    nps: this.detalhes.nps_id,
                    quizHotelId: this.detalhes.hotel_quiz_id,
                    empresaHotelId: this.detalhes.empresa_hotel_id
                });

                if (response.data) {

                    successToast('Follow-up registrado com sucesso!');
                    this.followUp.observacao = '';
                    this.showFollowUpForm = false;
                    await this.loadFollowUps();
                }
            } catch (error) {
                console.error('Erro ao salvar follow-up:', error);

                errorToast('Erro ao registrar follow-up. Tente novamente.');
            }
        }
    },
    mounted() {
        const modal = document.getElementById('modal-detalhes-nps-detratores');
        modal.addEventListener('shown.bs.modal', () => {
            this.tabs = 0;  // Reseta para a tab Respostas
            this.loadFollowUps();
            this.loadRespostas();
        });
    },
    watch: {
        'detalhes.id': {
            immediate: true,
            handler(newVal) {
                this.followUps = [];
                this.respostas = [];
                if (newVal) {
                    this.loadFollowUps();
                    this.loadRespostas();
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.table-pesquisa {
    height: 400px;
    max-height: 400px;
    overflow: scroll;
}

.body-card {
    padding: 10px;
}

.modal {
    z-index: 10000 !important;
}

.card {
    border: 0.4px solid #d1d8df;
    padding: 0.5rem;

    .badge {
        font-size: 0.75rem !important;
        padding: 0.45em 0.775em !important;
    }

    label {
        margin-bottom: 0 !important;
    }

    .card-header {
        border-bottom: 1px solid #e9ecef
    }

    .card-footer {
        border-top: 1px solid #e9ecef;
    }

    .card-body {
        padding: 1rem;

        label {
            text-align: left;
        }
    }

    .overflow-text {
        width: 100%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .comentario {
        max-height: 60px;
        overflow-y: auto;
        white-space: pre-wrap;
    }

    .badge {
        padding: 8px 10px 0px 10px;
        font-size: 0.65rem;
        font-weight: 700;
        border-radius: 0.5rem;

        &.badge-success {
            background-color: #198754;
            color: white;
        }

        &.badge-warning {
            background-color: #ffc107;
            color: black;
        }

        &.badge-danger {
            background-color: #dc3545;
            color: white;
        }
    }
}

.limit-div {
    overflow-x: auto;
    height: 400px;
    max-height: 400px;
}

.timeline-container {
    padding: 20px 0;
    position: relative;
    overflow-x: auto;
    height: 400px;
    max-height: 400px;
}

.timeline {
    position: relative;
    padding-left: 30px;
}

.timeline::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #e9ecef;
}

.timeline-item {
    position: relative;
    margin-bottom: 30px;
}

.timeline-item:last-child {
    margin-bottom: 0;
}

.timeline-dot {
    position: absolute;
    left: -20px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #5e72e4;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #5e72e4;
    top: 5px;
}

.timeline-content {
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid #e9ecef;
    width: auto !important;
}

.timeline-date {
    color: #4b545f;
    font-size: 0.875rem;
    margin-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 8px;
}

.date-group {
    display: flex;
    justify-content: space-between;
}

.date-group div {
    display: flex;
    align-items: center;
}

.date-label {
    font-weight: 600;
    margin-right: 4px;
}

.timeline-body {
    color: #344767;
    line-height: 1.5;
    white-space: pre-line;
}

.timeline-container .text-center i {
    display: block;
    margin-bottom: 10px;
}

.follow-up-counter {
    text-align: right;
}

.counter-badge {
    display: inline-flex;
    align-items: center;
    background: #f8f9fa;
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid #e9ecef;
}

.counter-number {
    font-weight: 600;
    color: #5e72e4;
    margin: 0 6px;
    font-size: 1.1rem;
}

.counter-text {
    color: #8898aa;
    font-size: 0.9rem;
}

.contatos-header {
    font-size: 0.9rem;
    color: #8898aa;
}

.contatos-header i {
    color: #5e72e4;
}

.contatos-header span {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    background: #f8f9fa;
    border-radius: 4px;
}

.filtros-container {
    display: flex;
    gap: 1rem;
    align-items: center;
    padding: 0.5rem 0;

    .search-container {
        flex: 1;

        .input-group {
            .input-group-text {
                background-color: white;

                i {
                    color: #8898aa;
                }
            }

            .form-control {

                &:focus {
                    border-color: #e9ecef;
                    box-shadow: none;
                }
            }
        }
    }

    .sort-container {
        width: 200px;

        .form-select {
            border-radius: 0.5rem;
            border-color: #e9ecef;
            color: #344767;
            font-size: 0.875rem;

            &:focus {
                border-color: #5e72e4;
                box-shadow: none;
            }
        }
    }
}
</style>